module.exports = __webpack_public_path__ + "static/fabricsOfIndia-a074bad9e40f341c528deb0dcbd9317f.png";